import request from '@/utils/request';
import store from '@/store';
// 获取当前酒店基础设置配置详情
export function getBaseInfo() {
  return request({
    url: '/system/settings/base/info',
    method: 'get',
  });
}

//   查询夜审日志
export function getBaseLog(query) {
  return request({
    url: '/system/settings/base/business_day/log',
    method: 'get',
    params: query,
  });
}
//   更新营业日相关配置
export function updateBusinessDay(data) {
  return request({
    url: '/system/settings/base/business_day',
    method: 'put',
    data,
  });
}
//   更新夜审相关配置
export function updateNightTrial(data) {
  return request({
    url: '/system/settings/base/night_trial',
    method: 'put',
    data,
  });
}
//   更新交接班模式配置
export function updateReserveFund(data) {
  return request({
    url: '/system/settings/base/reserve_fund',
    method: 'put',
    data,
  });
}
//   更新班次信息配置
export function updateOrderinfo(data) {
  return request({
    url: '/system/settings/base/shifts',
    method: 'put',
    data,
  });
}
// 获取当前酒店的打印配置
export function fetchPrintSettings(params) {
  return request({
    url: '/system/settings/print/query',
    method: 'get',
    params,
  });
}
// 保存当前酒店的打印配置
export function cavePrintSettings(params) {
  return request({
    url: '/system/settings/print/save',
    method: 'post',
    data: params,
  });
}
// 删除当前酒店的打印配置
export function deletePrintSettings(id) {
  return request({
    url: `/system/goods/print/settings/${id}`,
    method: 'post',
  });
}
// 查询字典表
export function fetchPrintDicList(params) {
  return request({
    url: '/system/settings/print/dict',
    method: 'get',
    params,
  });
}
// 修改备用金上线
export function editPrettyCashUp(params) {
  return request({
    url: '/system/settings/base/updateMaxPettyCash',
    method: 'put',
    params: {
      maxPettyCash: params.toString(),
    },
  });
}
// 修改备用金上线
export function editCurrentPrettyCash(params) {
  return request({
    url: '/system/settings/base/updateCurrentPettyCash',
    method: 'put',
    params: {
      currentPettyCash: params,
    },
  });
}
// 设置班次
export function setTurns(data) {
  return request({
    url: `/system/settings/base/shift/logs`,
    method: 'post',
    data,
  });
}
// 查询续住服务消息雷白
export function fetchStayOverServiceList(params) {
  return request({
    url: '/system/hotel/notice/tasks/applyContinuedResidence',
    method: 'get',
    params,
  });
}
// 线上新订单提醒
export function orderCreateNoticeSettingChange(params) {
  return request({
    url: '/system/settings/base/order/create/voice/enabled',
    method: 'put',
    params: {
      enabled: params,
    },
  });
}
// 线上新订单取消提醒
export function orderCancelNoticeSettingChange(params) {
  return request({
    url: '/system/settings/base/order/cancel/voice/enabled',
    method: 'put',
    params: {
      enabled: params,
    },
  });
}

// 小商品库存管理接口
// 导出库存
export function exportRealTimesStockList(params) {
  return request({
    url: '/erp/storage/export/list',
    method: 'get',
    responseType: 'blob',
    params,
  });
}
// 查询实时库存列表
export function fetchRealTimeStockList(params) {
  return request({
    url: '/erp/storage/list',
    method: 'get',
    params,
  });
}
// 修改库存单价
export function updateUnitPrice(params) {
  return request({
    url: '/erp/storage/update/price',
    method: 'get',
    params,
  });
}
// 修改库存售卖状态
export function updateSellStatus(params) {
  return request({
    url: '/erp/storage/update/salestatus',
    method: 'get',
    params,
  });
}
// 查询入库列表
export function fetchIncomingStockList(params) {
  return request({
    url: '/erp/storage/in/list',
    method: 'get',
    params,
  });
}
// 查询是否存在未删除的库存信息
export function queryIsExistHistory(params) {
  return request({
    url: '/erp/storage/isExist',
    method: 'get',
    params,
  });
}
// 新增入库信息
export function addIncomingStockRecord(params) {
  return request({
    url: '/erp/storage/in/create',
    method: 'post',
    data: params,
  });
}
// 修改入库信息
export function updateIncomingStockRecord(params) {
  return request({
    url: '/erp/storage/in/update',
    method: 'post',
    data: params,
  });
}
// 查询出库列表
export function queryOutStockList(params) {
  return request({
    url: '/erp/storage/out/list',
    method: 'get',
    params,
  });
}
// 添加出库
export function addOutStockRecord(params) {
  return request({
    url: '/erp/storage/out/create',
    method: 'post',
    data: params,
  });
}
// 撤销出库单
export function reverseOutStockRecord(params) {
  return request({
    url: '/erp/storage/out/repeal',
    method: 'get',
    params,
  });
}

// 自动排房设置开关
export function autoRoomArrangeChange(params) {
  return request({
    url: '/system/settings/base/order/room/auto/arrange/enabled',
    method: 'put',
    params: {
      enabled: params,
      hotelCode: store.state.user.hotelCode,
    },
  });
}

// 自动排房设置处理提交
export function saveAutoRoomArrangeConfig(data) {
  return request({
    url: '/system/settings/base/order/room/auto/arrange/config',
    method: 'post',
    data,
  });
}

// 查询物料列表
export function queryMaterailList(params) {
  return request({
    url: '/erp/material/list',
    method: 'get',
    params,
  });
}
// 查询物料排序列表
export function queryMaterialSortList() {
  return request({
    url: '/erp/material/sort/list',
    method: 'get',
  });
}
// 保存物料排序
export function updateMaterialSort(data) {
  return request({
    url: '/erp/material/sort',
    method: 'post',
    data,
  });
}
// 新增物料
export function addMaterail(params) {
  return request({
    url: '/erp/material/create',
    method: 'post',
    data: params,
  });
}
// 修改物料
export function updateMaterail(params) {
  return request({
    url: '/erp/material/update',
    method: 'post',
    data: params,
  });
}
// 删除物料
export function deleteMaterail(params) {
  return request({
    url: '/erp/material/del',
    method: 'get',
    params,
  });
}
// 更新物料状态
export function updateMaterailStatus(params) {
  return request({
    url: '/erp/material/update/status',
    method: 'get',
    params,
  });
}
// 查询物料类型和物料名称集合(用于售卖)
export function fetchMaterailEnumerationsToSell(params) {
  return request({
    url: '/erp/material/gather',
    method: 'get',
    params,
  });
}

export function fetchItemTypeList(params) {
  return request({
    url: '/erp/item/type/list',
    method: 'get',
    params,
  });
}

export function fetchItemTypeAll() {
  return request({
    url: '/erp/item/type/all',
    method: 'get',
  });
}

export function createItemType(data) {
  return request({
    url: '/erp/item/type/create',
    method: 'post',
    data,
  });
}

export function updateItemType(data) {
  return request({
    url: '/erp/item/type/update',
    method: 'post',
    data,
  });
}

export function deleteItemType(params) {
  return request({
    url: '/erp/item/type/del',
    method: 'get',
    params,
  });
}

export function fetchItemSpecList(params) {
  return request({
    url: '/erp/item/spec/list',
    method: 'get',
    params,
  });
}

export function fetchItemSpecAll() {
  return request({
    url: '/erp/item/spec/all',
    method: 'get',
  });
}

export function createItemSpec(data) {
  return request({
    url: '/erp/item/spec/create',
    method: 'post',
    data,
  });
}

export function updateItemSpec(data) {
  return request({
    url: '/erp/item/spec/update',
    method: 'post',
    data,
  });
}

export function deleteItemSpec(params) {
  return request({
    url: '/erp/item/spec/del',
    method: 'get',
    params,
  });
}
// 查询物料类型和规格单位枚举
export function fetchDicListByCode(params) {
  return request({
    url: '/erp/dict/list',
    method: 'get',
    params,
  });
}
// 查询物料类型和物料名称集合(用于售卖)
export function fetchMaterailEnumerationsToStock(params) {
  return request({
    url: '/erp/material/getName',
    method: 'get',
    params,
  });
}
// 超售自动接单开关
export function oversaleAutoBookingStatusChange(params) {
  return request({
    url: '/system/settings/base/order/auto/task/overbooking/enabled',
    method: 'put',
    params: {
      enabled: params,
    },
  });
}
// 查询当前的班次
export function getCurrentUserShift(params) {
  return request({
    url: '/system/settings/base/user/shift/info',
    method: 'get',
    params,
  });
}
// 钟点房自动接单开关
export function hourRoomStatusChange(params) {
  return request({
    url: '/system/settings/base/order/hour/auto/receive/enabled',
    method: 'put',
    params: {
      enabled: params,
    },
  });
}
// 直连订单自动入ar账设置
export function autoEnterArChange(params) {
  return request({
    url: '/system/settings/base/order/autoEnterAr',
    method: 'get',
    params: {
      enabled: params,
    },
  });
}
// 获取服务器时间
export function fetchSystemTime(data) {
  return request({
    url: `/system/hotel/night/trial/systemtime`,
    method: 'get',
    params: data,
  });
}
// 获取默认离店时间
export function getDefaultLeaveTime(params) {
  return request({
    url: '/order/houseKeeper/queryHotelDepartureHotelTime',
    method: 'get',
    params,
  });
}
// 获取城市运营经理和技术支持信息
export function fetchServieInfo(params) {
  return request({
    url: '/system/settings/cityOperator/telephone',
    method: 'get',
    params,
  });
}
// 判断散客步入是否是灰度环境
export function judgeIsCheckInGrayEnv(params) {
  return request({
    url: '/system/settings/fe/hotel/config',
    method: 'get',
    params: {
      ...params,
      key: 'walkInGray',
    },
  });
}
// 设置Wi-Fi信息
export function setWifi(params) {
  return request({
    url: '/system/settings/mis/wifi/save',
    method: 'post',
    data: params,
  });
}
// 查询Wi-Fi信息
export function getWifiConfig(params) {
  return request({
    url: '/system/settings/mis/wifi/detail',
    method: 'get',
  });
}
// 消息提示设置
export function getNotifyTime(params) {
  return request({
    url: '/system//settings/base/order/checkout/notify/time',
    method: 'put',
    data: params,
    notCheckRepeat: true,
  });
}
export function getNotifyVoice(params) {
  return request({
    url: '/system//settings/base/order/checkout/notify/voice',
    method: 'put',
    data: params,
    notCheckRepeat: true,
  });
}
// 灰度配置接口
export function grayJudge() {
  return request({
    url: '/system/settings/fe/hotel/config',
    method: 'get',
    params: { key: 'phoneConfusion' },
  });
}

// 获取指定展示位的资源列表
export function validBanner(params) {
  return request({
    url: '/admin/market/banner/validBanner',
    method: 'get',
    params,
  });
}

// 获取路由的显示隐藏
export function sassMenuHide(params) {
  return request({
    url: '/rms/miniPms/hotel/sassMenuHide',
    method: 'get',
    params,
  });
}

//酒店房态图风格查询接口  （用于房态图配置编辑回显）
export function getConfigByHotelAndStyle(params) {
  return request({
    url: '/system/settings/roomStyle/getConfigByHotelAndStyle',
    method: 'get',
    params,
  });
}

//酒店房态图风格查询接口  （房态图查询）
export function currentHotelConfigStyle(params) {
  return request({
    url: '/system/settings/roomStyle/currentHotelConfigStyle',
    method: 'get',
    params,
  });
}

//房态图自字义风格保存接口
export function roomStyleSave(data) {
  return request({
    url: '/system/settings/roomStyle/save',
    method: 'post',
    data,
  });
}

//修改房价审核配置范围
export function getModifyPriceConfig(params) {
  return request({
    url: 'dynamic/info/getModifyPriceConfig',
    method: 'get',
    params,
  });
}

//修改房价审核配置范围
export function modifyPriceConfig(params) {
  return request({
    url: '/dynamic/info/modifyPriceConfig',
    method: 'get',
    params,
  });
}

//查询目标设定信息
export function getHotelMonthlyGoal(params) {
  return request({
    url: '/system/settings/getHotelMonthlyGoal',
    method: 'get',
    params,
  });
}

//收益预警设置查询
export function saveHotelMonthlyGoal(data) {
  return request({
    url: '/system/settings/saveHotelMonthlyGoal',
    method: 'post',
    data,
  });
}

//修改目标设定信息
export function getHotelMonthlyProfitAlertSettings(params) {
  return request({
    url: '/system/settings/getHotelMonthlyProfitAlertSettings',
    method: 'get',
    params,
  });
}

//保存收益预警设置
export function saveHotelMonthlyProfitAlertSettings(data) {
  return request({
    url: '/system/settings/saveHotelMonthlyProfitAlertSettings',
    method: 'post',
    data,
  });
}

//日常预警查询接口
export function getDailyProfitAlertSettings(params) {
  return request({
    url: '/system/settings/getDailyProfitAlertSettings',
    method: 'get',
    params,
  });
}

//日常预警保存接口
export function saveDailyProfitAlertSettings(data) {
  return request({
    url: '/system/settings/saveDailyProfitAlertSettings',
    method: 'post',
    data,
  });
}
// 解绑接收人
export function unBindUser(params) {
  return request({
    url: '/system/settings/base/qgj/wxTemplate/unBindUser',
    method: 'get',
    params,
  });
}

// 满房后自动关闭eb房态开关设置保存
export function closeEnabled(params) {
  return request({
    url: '/system/settings/base/eb/goods/switch/auto/close/enabled',
    method: 'put',
    params: {
      enabled: params,
    },
  });
}

//eb库存自动同步系统库存开关设置保存
export function syncEnabled(params) {
  return request({
    url: '/system/settings/base/eb/goods/inv/auto/sync/enabled',
    method: 'put',
    params: {
      enabled: params,
    },
  });
}

//pms系统设置->押金配置保存
export function saveCheckinDeposit(data) {
  return request({
    url: '/system/settings/base/checkinDeposit/save',
    method: 'post',
    data,
  });
}

// 保存可开发票类型设置
export function openInvoiceType(data) {
  return request({
    url: '/system/settings/base/invoice/openInvoiceType',
    method: 'post',
    data,
  });
}
//新增商家查询账号列表
export function partnerUsersList(data) {
  return request({
    url: '/auth-api/v1/partner/user/list',
    method: 'post',
    data,
  });
}

// 新增商家查询账号详情
export function partnerUserDetail(params) {
  return request({
    url: '/auth-api/v1/partner/user/detail',
    method: 'get',
    params,
  });
}

//查询商家岗位(标准角色)、自定义角色接口
export function rolesListByHotel(params) {
  return request({
    url: '/auth-api/v1/partner/role/listByHotel',
    method: 'get',
    params,
  });
}

//新增商家账号状态启用、停用
export function partnerUserUpdateStatus(data) {
  return request({
    url: '/auth-api/v1/partner/user/updateStatus',
    method: 'post',
    data,
  });
}

//查询商家岗位(标准角色)、自定义角色接口
export function partnerRolesList(data) {
  return request({
    url: '/auth-api/v1/partner/role/list',
    method: 'post',
    data,
  });
}

//新增商家账号保存接口
export function partnerUserSave(data) {
  return request({
    url: '/auth-api/v1/partner/user/save',
    method: 'post',
    data,
  });
}

//新增商家角色状态启用、停用
export function partnerRolesUpdateStatus(data) {
  return request({
    url: '/auth-api/v1/partner/role/updateStatus',
    method: 'post',
    data,
  });
}

//新增商家账号逻辑删除接口
export function partnerserDelete(data) {
  return request({
    url: '/auth-api/v1/partner/user/delete',
    method: 'post',
    data,
  });
}

//新增商家角色逻辑删除接口
export function partnerRolesDelete(data) {
  return request({
    url: '/auth-api/v1/partner/role/delete',
    method: 'post',
    data,
  });
}

//新增商家查询自定义角色详情
export function partnerRolesDetail(params) {
  return request({
    url: '/auth-api/v1/partner/role/detail',
    method: 'get',
    params,
  });
}

//新增商家自定义角色权限查询接口
export function partnerRolesResources(params) {
  return request({
    url: '/auth-api/v1/partner/role/resources',
    method: 'get',
    params,
  });
}

//新增商家设置自定义角色权限保存接口
export function partnerRolesSaveResources(data) {
  return request({
    url: '/auth-api/v1/partner/role/saveResources',
    method: 'post',
    data,
  });
}

//新增商家自定义角色创建接口
export function partnerRolesSave(data) {
  return request({
    url: '/auth-api/v1/partner/role/save',
    method: 'post',
    data,
  });
}
//入库导出
export function storageAndExport(params) {
  return request({
    url: '/erp/storage/in/export/list',
    method: 'get',
    responseType: 'blob',
    params,
  });
}

//出库导出
export function outboundExport(params) {
  return request({
    url: 'erp/storage/out/export/list',
    method: 'get',
    responseType: 'blob',
    params,
  });
}

//增加酒店支持同步switch订单渠道设置保存
export function syncSwitchCfg(params) {
  return request({
    url: '/system/settings/base/info/syncSwitchCfg/enabled',
    method: 'put',
    params: {
      enabled: params,
    },
  });
}

// 查询客房服务派单配置
export function getConfigByHotelCode(params) {
  return request({
    url: '/system/settings/roomClean/getConfigByHotelCode',
    method: 'get',
    params,
  });
}

// 查询酒店保洁列表
export function queryCleaners(params) {
  return request({
    url: '/system/settings/roomClean/queryCleaners',
    method: 'get',
    params,
  });
}

// 保存客房服务派单配置
export function saveConfig(data) {
  return request({
    url: '/system/settings/roomClean/saveConfig',
    method: 'post',
    data,
  });
}

//新增信息修改接口
export function setHandOverToTheNextShiftReportShow(data) {
  return request({
    url: `/system/settings/base/reportShow/setHandOverToTheNextShiftReportShow`,
    method: 'post',
    data,
  });
}

//设置是否强制加收房费
export function forceAddRoomFee(params) {
  return request({
    url: '/system/settings/base/forceAddRoomFee/enabled',
    method: 'get',
    params,
  });
}

//设置全日房加收房费规则
export function fulldayAddRoomRule(params) {
  return request({
    url: '/system/settings/base/fulldayAddRoomRule',
    method: 'get',
    params,
  });
}

//新增信息修改接口
export function saveRoomArrangeOverlapHr(data) {
  return request({
    url: `/system/settings/base/roomArrangeOverlapHr/save`,
    method: 'post',
    data,
  });
}

//新增信息修改接口
export function enableOrDisableAllScene(data) {
  return request({
    url: `/system/settings/base/qgj/wxTemplate/enableOrDisableAllScene`,
    method: 'post',
    data,
  });
}

//新增信息修改接口
export function updateSenceConfig(data) {
  return request({
    url: `/system/settings/base/qgj/wxTemplate/updateSenceConfig`,
    method: 'post',
    data,
  });
}

// checkPhoneExists
export function checkPhoneExists(params) {
  return request({
    url: '/auth-api/v1/users/getUserByPhone',
    method: 'get',
    params,
  });
}

// 未读订单消息list
export function unReadMessagess(data) {
  return request({
    url: '/system/hotel/messages/unReadMessages',
    method: 'post',
    notCheckRepeat: true,
    data,
  });
}

// 单条已读
export function singleRead(params) {
  return request({
    url: '/system/hotel/message/read/' + params.id,
    method: 'put',
    notCheckRepeat: true,
    params,
  });
}

// 全部已读
export function allRead(data) {
  return request({
    url: '/system/hotel/messages/readOtherTypeMessages',
    method: 'post',
    notCheckRepeat: true,
    data,
  });
}

// 全部已读
export function allebAccount(params) {
  return request({
    url: '/system/hotel/message/ebAccount/read',
    method: 'put',
    params,
  });
}

//新增信息修改接口
export function homepageTodoList(data) {
  return request({
    url: `/system/homepage/homepageTodoList`,
    method: 'post',
    data,
  });
}

//单个待办事项已读
export function dealSingleTodoTask(data) {
  return request({
    url: `/system/homepage/dealSingleTodoTask`,
    method: 'post',
    data,
  });
}

//一键已读待办事项
export function dealAllTodoTask(data) {
  return request({
    url: `/system/homepage/dealAllTodoTask`,
    method: 'post',
    data,
  });
}

//新增/移动/删除模块接口
export function buildPageLayout(data) {
  return request({
    url: `/system/homepage/buildPageLayout`,
    method: 'post',
    data,
  });
}

// 获取所有大模块
export function getAllHomePageModules(params) {
  return request({
    url: '/system/homepage/getAllHomePageModules',
    method: 'get',
    params,
  });
}

// 获取所有功能点接口(用于选择界面)
export function getAllFunctionItem(params) {
  return request({
    url: '/system/homepage/getAllFunctionItem',
    method: 'get',
    params,
  });
}

// 获取所有数据
export function getHomePageModuleData(params) {
  return request({
    url: '/system/homepage/getHomePageModuleData',
    method: 'get',
    params,
  });
}

// 页面布局样式接口
export function homePageByHotelCode(params) {
  return request({
    url: '/system/homepage/homePageByHotelCode',
    method: 'get',
    params,
  });
}

//更新会员支付需要验证码配置
export function memberPayWithoutCode(params) {
  return request({
    url: '/system/settings/base/info/memberPayWithoutCode/enabled',
    method: 'put',
    params: {
      enabled: params,
    },
  });
}

export function updateIsRequiredId(data) {
  return request({
    url: `/system/settings/base/info/updateIsRequiredId/enabled?enabled=${data.enabled}`,
    method: 'put',
    data,
  });
}

// 获取区号
export function getDialingCodeList(data) {
  return request({
    url: `/admin/baseInfo/countryDimension/getDialingCode`,
    method: 'get',
    params: data,
  });
}

// 用户习惯维护
export function addOrUpdateUserHabits(data) {
  return request({
    url: `/system/settings/base/info/addOrUpdateUserHabits`,
    method: 'post',
    data,
  });
}

// 查询用户习惯
export function queryUserHabits(data) {
  return request({
    url: `/system/settings/base/info/queryUserHabits`,
    method: 'get',
    params: data,
  });
}

export function updateMorningOrderCheckInAddFee(data) {
  return request({
    url: `/system/settings/base/order/create/morningOrderCheckInAddFee`,
    method: 'get',
    params: data,
  });
}

export function updateIsTempMakeCard(data) {
  return request({
    url: `/system/settings/base/info/updateIsTempMakeCard/enabled?enabled=${data.enabled}`,
    method: 'post',
    data,
  });
}

// 更新早餐报表统计规则
export function updateBreakfastReportRuleCtrl(data) {
  return request({
    url: `/system/settings/base/info/updateBreakfastCtrl/enabled?enabled=${data.enabled}`,
    method: 'put',
    data,
  });
}

export function updateHideCheckInRegisterRoomPrice(data) {
  return request({
    url: `/system/settings/base/info/updateHideCheckInRegisterRoomPrice/enabled?enabled=${data.enabled}`,
    method: 'put',
    data,
  });
}
